import { FilterDocument, User } from '@griply/types';

import { defaultAllTasksFilterDocument } from './constants/default-all-tasks-filter-document';

export const getAllTasksFilterDocument = (
  user: User | undefined | null,
): FilterDocument => {
  return user?.settings?.filters?.allTasks ?? defaultAllTasksFilterDocument;
};
